var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamante(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Diamante"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.37416 6.75H16.6242M7.99916 2.25L6.49916 6.75L9.49916 15.375L12.4992 6.75L10.9992 2.25M9.9601 15.1969L16.6791 7.13411C16.7929 6.99746 16.8499 6.92914 16.8716 6.85287C16.8908 6.78563 16.8908 6.71437 16.8716 6.64712C16.8499 6.57086 16.7929 6.50253 16.6791 6.36589L13.4291 2.46589C13.3629 2.38653 13.3299 2.34685 13.2893 2.31833C13.2534 2.29306 13.2134 2.27429 13.1709 2.26288C13.1231 2.25 13.0714 2.25 12.9681 2.25H6.03019C5.92689 2.25 5.87524 2.25 5.82738 2.26288C5.78497 2.27429 5.7449 2.29306 5.70898 2.31833C5.66845 2.34685 5.63539 2.38653 5.56926 2.46589L2.31926 6.36589C2.20538 6.50253 2.14845 6.57086 2.12669 6.64712C2.10751 6.71436 2.10751 6.78563 2.12669 6.85287C2.14845 6.92914 2.20538 6.99746 2.31926 7.13411L9.03823 15.1969C9.19652 15.3868 9.27567 15.4818 9.37043 15.5164C9.45356 15.5468 9.54476 15.5468 9.6279 15.5164C9.72266 15.4818 9.8018 15.3868 9.9601 15.1969Z",
    stroke: "#0575E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamante);
export default __webpack_public_path__ + "static/media/Diamante.788d1819d26bc46130c4fe83bc70623a.svg";
export { ForwardRef as ReactComponent };